import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Calendar, TrendingUp, Target, Award, Users, BarChart } from 'lucide-react';

const CryptoNews = () => {
  return (
    <div className="min-h-screen bg-book-cream">
      <Header />
      <main className="book-section">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center space-x-2 mb-4">
              <Calendar className="h-6 w-6 text-book-brown" />
              <span className="text-book-brown-dark font-medium">06.12.2025</span>
              <span className="bg-indigo-100 text-indigo-800 px-3 py-1 rounded-full text-sm font-medium">Technology</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-book-brown mb-6">
              Cryptocurrency Integration Transforms UK Online Casinos
            </h1>
            <p className="text-xl text-book-brown-dark leading-relaxed">
              Blockchain technology enables instant, secure transactions while regulatory frameworks adapt to accommodate
              digital currencies in mainstream gaming.
            </p>
          </div>

          <div className="mb-12 bg-gradient-to-br from-book-brown to-book-brown-light rounded-xl p-8 text-center text-book-cream">
            <TrendingUp className="h-16 w-16 mx-auto mb-4 opacity-80" />
            <img
              src="/images/marco-ribbe-DZ2FvK0eLjQ-unsplash.webp"
              alt="Crypto Casino Integration"
              className="w-full h-64 object-cover rounded-lg"
            />
            <p className="text-sm opacity-75">Digital Currency Revolution</p>
          </div>

          <div className="mb-16 bg-book-beige rounded-xl p-8 shadow-book-inset">
            <h2 className="text-2xl font-bold text-book-brown mb-6 text-center">Our News Curation Philosophy</h2>
            <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed">
              <p>Every guide published on Brit Ember represents extensive research and deep industry insights...</p>
            </div>
          </div>

          <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed mb-12">
            <h2 className="text-3xl font-bold text-book-brown mb-6">The Cryptocurrency Gaming Revolution</h2>
            <p>Cryptocurrency integration represents a fundamental transformation of online casino infrastructure...</p>
          </div>

          <div className="mb-12">
            <h2 className="text-3xl font-bold text-book-brown mb-8 text-center">Cryptocurrency Adoption Metrics</h2>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">Transaction Speed</h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">Crypto Deposits</span>
                    <span className="font-semibold text-green-600">&lt;1 min</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">Traditional Cards</span>
                    <span className="font-semibold text-yellow-600">3-5 min</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">Bank Transfers</span>
                    <span className="font-semibold text-orange-600">1-3 days</span>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">Security Enhancement</h3>
                <div className="flex justify-center mb-4">
                  <div className="relative w-48 h-48">
                    <svg viewBox="0 0 100 100" className="w-full h-full">
                      <circle cx="50" cy="50" r="40" fill="none" stroke="#FFD700" strokeWidth="20"/>
                      <circle cx="50" cy="50" r="40" fill="none" stroke="#228B22" strokeWidth="20" strokeDasharray="125.66" strokeDashoffset="31.42"/>
                    </svg>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <span className="text-2xl font-bold text-book-brown">95%</span>
                    </div>
                  </div>
                </div>
                <div className="text-center text-sm text-book-brown-dark">
                  Improvement over traditional methods
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">Fee Reduction</h3>
                <div className="space-y-4">
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <span className="text-book-brown-dark">International Transfers</span>
                      <div className="flex-1 mx-4 bg-gray-200 rounded-full h-3">
                        <div className="bg-green-500 h-3 rounded-full" style={{width: '80%'}}></div>
                      </div>
                      <span className="font-semibold text-green-600">80% less</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-book-brown-dark">Cross-border Fees</span>
                      <div className="flex-1 mx-4 bg-gray-200 rounded-full h-3">
                        <div className="bg-green-500 h-3 rounded-full" style={{width: '90%'}}></div>
                      </div>
                      <span className="font-semibold text-green-600">90% less</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed">
            <p>Cryptocurrency integration represents a fundamental transformation of online casino infrastructure...</p>
            <div className="bg-book-beige rounded-lg p-6 my-8">
              <h4 className="text-xl font-bold text-book-brown mb-4">Blockchain Benefits for Players</h4>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <Target className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Near-instantaneous deposits and withdrawals</span>
                </li>
                <li className="flex items-start">
                  <Award className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Enhanced privacy and financial confidentiality</span>
                </li>
                <li className="flex items-start">
                  <Users className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Reduced transaction fees and currency conversion costs</span>
                </li>
                <li className="flex items-start">
                  <BarChart className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Global accessibility without banking restrictions</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CryptoNews;
